import type { SVGProps } from "react";

/**
 * expand-simple
 * @category Arrows
 */
export default function IconExpandSimple(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M5.75 12.75V16.25C5.75 17.3546 6.64543 18.25 7.75 18.25H11.25M12.75 5.75H16.25C17.3546 5.75 18.25 6.64543 18.25 7.75V11.25'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
